import { api } from './index';

export type AppNotificationType =
  | 'GENERAL'
  | 'CHAT_MESSAGE'
  | 'BOOKING_CONFIRMATION'
  | 'BOOKING_CANCELLATION'
  | 'CONSTRUCTION_REGISTRATION'
  | 'CONSTRUCTION_CONFIRMATION'
  | 'CONSTRUCTION_CANCELLATION'
  | 'CONSTRUCTION_START'
  | 'CONSTRUCTION_COMPLETION'
  | 'CONSTRUCTION_DEPOSIT'
  | 'CONSTRUCTION_DEPOSIT_REFUND'
  | 'FEE_NOTIFICATION'
  | 'PAYMENT_CONFIRMATION'
  | 'TASK_ASSIGNMENT'
  | 'TASK_UPDATE'
  | 'FEEDBACK_RESPONSE'
  | 'SYSTEM_ANNOUNCEMENT';

export interface AppNotification {
  id: string;
  userId: string;
  buildingId: string | null;
  type: AppNotificationType | string;
  title: string;
  message: string;
  data: Record<string, unknown> | string | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
  updatedAt: string;
  building?: { name: string } | null;
}

export interface NotificationCounts {
  total: number;
  unread: number;
  byType: {
    chat: number;
    booking: number;
    construction: number;
    fee: number;
    payment: number;
    task: number;
    feedback: number;
    system: number;
  };
}

export interface ListNotificationsParams {
  buildingId?: string;
  isRead?: boolean;
  limit?: number;
  offset?: number;
}

export const notificationsApi = {
  list: async (params: ListNotificationsParams = {}): Promise<AppNotification[]> => {
    const query: Record<string, string> = {};
    if (params.buildingId) query.buildingId = params.buildingId;
    if (params.isRead !== undefined) query.isRead = String(params.isRead);
    query.limit = String(params.limit ?? 50);
    query.offset = String(params.offset ?? 0);
    const response = await api.get<AppNotification[]>('/notifications', { params: query });
    return response.data;
  },

  getCounts: async (buildingId?: string): Promise<NotificationCounts> => {
    const params = buildingId ? { buildingId } : undefined;
    const response = await api.get<NotificationCounts>('/notifications/counts', { params });
    return response.data;
  },

  getById: async (id: string): Promise<AppNotification> => {
    const response = await api.get<AppNotification>(`/notifications/${id}`);
    return response.data;
  },

  markAsRead: async (id: string): Promise<AppNotification> => {
    const response = await api.put<AppNotification>(`/notifications/${id}/read`);
    return response.data;
  },

  markAllAsRead: async (buildingId?: string): Promise<{ count: number }> => {
    const params = buildingId ? { buildingId } : undefined;
    const response = await api.put<{ count: number }>('/notifications/mark-all-read', undefined, {
      params,
    });
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/notifications/${id}`);
  },
};
